import { render, staticRenderFns } from "./SmartLink.vue?vue&type=template&id=65a2da15&scoped=true"
import script from "./SmartLink.vue?vue&type=script&setup=true&lang=ts"
export * from "./SmartLink.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SmartLink.vue?vue&type=style&index=0&id=65a2da15&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a2da15",
  null
  
)

export default component.exports